import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; 
import PromotionForm from '../../components/Promotion/PromotionForm';
import PromotionTable from '../../components/Promotion/PromotionTable';
import API from '../../services/api';
import { t } from "@lingui/macro";

const Promotions = () => {
  const navigate = useNavigate();
  const [showForm, setShowForm] = useState(false);
  const [showTable, setShowTable] = useState(false);

  const handleAddNewPromotion = () => {
    setShowForm(true);
  };

  const handleCancel = () => {
    setShowForm(false);
  };

  const handleSavePromotion = (promotionData) => {
    API.post('/api/promotions', promotionData)
      .then((response) => {
        console.log('Promotion saved:', response.data);
        setShowForm(false);
        navigate('/dashboard');
      })
      .catch((error) => {
        console.error('Error saving promotion:', error);
      });
  };

  return (
    <div>
      <h2>{t`Manage Promotions`}</h2>
      <p>{t`Create, update, and manage promotional campaigns.`}</p>

      {/* Button to toggle promotion table */}
      <button 
        className="add-new-btn"
        onClick={() => setShowTable(!showTable)}
      >
        {showTable ? t`Hide Promotions` : t`Show Promotions`}
      </button>

      {/* Render table only when showTable is true */}
      {showTable && <PromotionTable />}

      {/* Button to add new promotion */}
      {!showForm && (
        <button 
          className="add-new-btn"
          onClick={handleAddNewPromotion}
        >
          {t`Add New Promotion`}
        </button>
      )}

      {/* Promotion form */}
      {showForm && (
        <PromotionForm
          onSave={handleSavePromotion}
          onCancel={handleCancel}
        />
      )}
    </div>
  );
};

export default Promotions;
